import { deriveWorkflowDetailPresentation } from '@/features/rpa/recorder/lib/derive-workflow-detail-presentation';
import { parseWorkflow } from '@/features/rpa/recorder/lib/parse-workflow';
import type { WorkflowDetailPresentation } from '@/features/rpa/recorder/types/workflow-detail';
import { coerceWorkflowWirePayload } from '@/tauri/rpa-recorder/upload-types';
import type { RecordedWorkflowMetadata } from '@heidi/agents/data';
import { createRecordedWorkflowMetadataReader } from '@heidi/agents/data';
export type RpaSkillWorkflowDisplay =
  RecordedWorkflowMetadata<WorkflowDetailPresentation>;
export const readRpaSkillWorkflowFromMetadata = createRecordedWorkflowMetadataReader(
  (payload, untitledFallback) =>
    deriveWorkflowDetailPresentation({
      bridgeAvailable: true,
      isLoading: false,
      isError: false,
      parseResult: parseWorkflow(coerceWorkflowWirePayload(payload)),
      untitledFallback,
    })
);
